import { IStringDate } from './types';

export const getQuarter = (date: IStringDate): number => {
  const month = Number(date.split('-')[1]);
  return Math.floor(month / 3) + 1;
};
